<template>
  <div class="edit-report-dailog container-block col-block">
    <div class="title-container row-block default-shadow">
      <div class="row-block" :style="{ width: '35px' }"></div>
      <div
        class="title"
        v-html="param.title"
      ></div>
      <div class="row-block close-button" :style="{ width: '35px' }">
        <!-- <img :src="require('../../assets/images/analysis-close-icon.svg')" @click="e => $emit('changeModal')"> -->
      </div>
    </div>
    <div class="report-container col-block" :style="{ flex: 1 }">
      <customRowForm
        :init="report"
        :alerts="alerts"
        :disabled="!param.editable"
        :forms="formOptions['field1']"
        @change="(result, validate, errors) => formOnChange('field1', result, validate, errors)"
      ></customRowForm>
      <customRowForm
        :init="report"
        :alerts="alerts"
        :disabled="!param.editable"
        :forms="formOptions['field2']"
        @change="(result, validate, errors) => formOnChange('field2', result, validate, errors)"
      ></customRowForm>
      <customRowForm
        :init="report"
        :alerts="alerts"
        :disabled="!param.editable"
        :forms="formOptions['field3']"
        @change="(result, validate, errors) => formOnChange('field3', result, validate, errors)"
      >
        <template slot="_ADDCOUNTRY" slot-scope="props">
          <div :name="props" class="_ADDCOUNTRY">
            <div class="add-country-container row-block stretch">
              <template v-if="editable">
                <button type="button" class="white-button" @click="e => addCountry()">
                  <span>加入</span>
                </button>
                <div :style="{ width: '20px' }"></div>
              </template>
              <div class="country-list row-block" :style="{ flex: 1, width: 0 }">
                <div class="country-block row-block" v-for="(country, index) in selectedCountrys" :key="index">
                  <div class="country-text row-block">
                    <div class="country-title" :title="country.title">{{ country.country.chinese_name }}</div>
                  </div>
                  <template v-if="editable">
                    <div :style="{ width: '5px' }"></div>
                    <img :src="require('../../assets/images/remove-file-icon.svg')" alt="" @click="e => removeCountry(country)">
                  </template>
                  <div :style="{ flex: 1 }"></div>
                </div>
              </div>
              <div class="country-alert" v-if="alerts['_ADDCOUNTRY'] && alerts['_ADDCOUNTRY'].type === 'error'">{{ alerts['_ADDCOUNTRY'].msg }}</div>
            </div>
          </div>
        </template>
      </customRowForm>
      <customRowForm
        :init="report"
        :alerts="alerts"
        :disabled="!param.editable"
        :forms="formOptions['field4']"
        @change="(result, validate, errors) => formOnChange('field4', result, validate, errors)"
      >
        <template slot="_CONTENT" slot-scope="props">
          <div :name="props" class="_CONTENT">
            <div class="content-container">
              <quillEditor
                v-if="editable"
                :style="{ height: '300px' }"
                :content="report.content"
                :options="quillOptions"
                @blur="e => onEditor('blur', e)"
                @focus="e => onEditor('focus', e)"
                @input="e => onEditor('input', e)"
                @change="e => onEditor('change', e)"
                @ready="e => onEditor('ready', e)"
              ></quillEditor>
              <div v-else class="content" v-html="report.content"></div>
            </div>
          </div>
        </template>
      </customRowForm>
      <customRowForm
        :init="report"
        :alerts="alerts"
        :disabled="!param.editable"
        :forms="formOptions['field5']"
        @change="(result, validate, errors) => formOnChange('field5', result, validate, errors)"
      >
        <template slot="_COVERS" slot-scope="props">
          <div :name="props" class="_COVERS">
            <div class="cover-container col-block stretch">
              <template v-if="editable">
                <div class="mask" :class="{ disabled: allCovers.length >= 1 }">
                  <label for="upload-cover"></label>
                  <input v-show="false" type="file" id="upload-cover" accept="image/*" multiple :disabled="allCovers.length >= 1" @change="e => fileTypeCheck(e, e => coverUpload(e), () => addToast('error', '圖檔'))">
                  <button class="main-button">
                    <span>選擇檔案</span>
                  </button>
                </div>
                <div :style="{ height: '5px' }"></div>
              </template>
              <div class="cover-list row-block" :style="{ flex: 1 }">
                <div class="cover-block row-block" v-for="(cover, index) in allCovers" :key="index">
                  <a class="cover-text row-block" :href="cover.url" target="_blank">
                    <div class="cover-title" :title="cover.name">{{ cover.name }}</div>
                    <div :style="{ width: '3px' }"></div>
                    <div class="cover-size">{{ '(' + convertFileSize(cover.size) + ')' }}</div>
                  </a>
                  <template v-if="editable">
                    <div :style="{ width: '15px' }"></div>
                    <img :src="require('../../assets/images/remove-file-icon.svg')" alt="" @click="e => removeCover(cover)">
                  </template>
                  <div :style="{ flex: 1 }"></div>
                </div>
              </div>
              <div class="file-alert" v-if="alerts['_COVERS'] && alerts['_COVERS'].type === 'error'">{{ alerts['_COVERS'].msg }}</div>
            </div>
          </div>
        </template>
      </customRowForm>
      <customRowForm
        :init="report"
        :alerts="alerts"
        :disabled="!param.editable"
        :forms="formOptions['field6']"
        @change="() => {}"
      >
        <template slot="_FILES" slot-scope="props">
          <div :name="props" class="_FILES">
            <div class="file-container row-block stretch">
              <template v-if="editable">
                <div class="mask">
                  <label for="upload-file"></label>
                  <input v-show="false" type="file" id="upload-file" multiple @change="e => fileUpload(e)">
                  <button class="main-button">
                    <span>選擇檔案</span>
                  </button>
                </div>
                <div :style="{ width: '20px' }"></div>
              </template>
              <div class="file-list row-block" :style="{ flex: 1, width: 0 }">
                <div class="file-block row-block" v-for="(file, index) in allFiles" :key="index">
                  <a class="file-text row-block" :href="file.url" target="_blank">
                    <div class="file-title" :title="file.name">{{ file.name }}</div>
                    <div :style="{ width: '3px' }"></div>
                    <div class="file-size">{{ '(' + convertFileSize(file.size) + ')' }}</div>
                  </a>
                  <template v-if="editable">
                    <div :style="{ width: '15px' }"></div>
                    <img :src="require('../../assets/images/remove-file-icon.svg')" alt="" @click="e => removeFile(file)">
                  </template>
                  <div :style="{ flex: 1 }"></div>
                </div>
              </div>
              <div class="file-alert" v-if="alerts['_FILES'] && alerts['_FILES'].type === 'error'">{{ alerts['_FILES'].msg }}</div>
            </div>
          </div>
        </template>
      </customRowForm>
      <div :style="{ height: '10px' }"></div>
      <template v-if="param.data && defaultData.id">
        <reportComment
          :reportID="param.data.id"
        ></reportComment>
        <div :style="{ height: '30px' }"></div>
      </template>
      <div class="button-container row-block">
        <div :style="{ flex: 1 }"></div>
        <button type="button" name="button" class="gray-button" @click="e => $emit('changeModal')">
          <span>{{ editable ? '取消' : '返回' }}</span>
        </button>
        <template v-if="editable">
          <div :style="{ flexBasis: '20px' }"></div>
          <button type="button" name="button" class="main-button" :class="{ loading: onSubmit }" :disabled="onError" @click="e => validateEditReport()">
            <span>{{ param.data ? '更新' : '送出'}}</span>
          </button>
        </template>
        <div :style="{ flex: 1 }"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getProductByCategorys, getAdminReport, postAdminReport, putAdminReport } from '../../api'
import reportComment from '../../components/report/comment'
import customRowForm from '../../components/tool/customRowForm'
import quillEditor from '../../components/tool/quillEditor'
import routeLoading from '../../mixins/routeLoading'
import toastMethods from '../../mixins/toastMethods'
import { convertFileSize, fileTypeCheck, imageReader, dateFormat } from '../../constants/global/util'

export default {
  components: {
    reportComment,
    customRowForm,
    quillEditor
  },
  mixins: [
    routeLoading,
    toastMethods
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      report: {
        title: '',
        year: '',
        publish_time: dateFormat(new Date(), 'yyyy-MM-ddThh:mm'),
        category: '',
        product_code: '',
        module: '',
        country: '',
        content: '',
        external_link: '',
        // custom
        _ADDCOUNTRY: '',
        _CONTENT: '',
        _COVERS: '',
        _FILES: ''
      },
      defaultData: {},
      selectedCountrys: [],
      // options
      productByCategorys: {},
      // covers
      covers: [],
      addCovers: [],
      removeCoverIDs: [],
      // files
      files: [],
      addFiles: [],
      removeFileIDs: [],
      // form
      alerts: {},
      result: {},
      validate: {},
      error: {},
      onSubmit: false
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'countrys'
    ]),
    onError () {
      return Object.values(this.alerts).filter(alert => alert && alert.type === 'error').length || Object.entries(this.error).some(([field, error]) => error.items.filter(item => this.formOptions[field].map(form => form.value).includes(item.field)).length)
    },
    allCovers () {
      return this.covers.concat(this.addCovers)
    },
    allFiles () {
      return this.files.concat(this.addFiles)
    },
    editable () {
      return !!this.param.editable
    },
    // static
    yearOptions () {
      let year = (new Date()).getFullYear()
      return [
        { title: '無', value: '無' },
        ...(new Array(year - 2000)).fill('').map((_, i) => ({ title: year - i + '', value: year - i + '' }))
      ]
    },
    categoryOptions () {
      return [
        ...Object.keys(this.productByCategorys).map(category => ({ title: category, value: category })),
        { title: '其他', value: '其他' }
      ]
    },
    productOptions () {
      return [
        ...Array.prototype.concat.apply([], Object.entries(this.productByCategorys).map(([category, products]) => Object.entries(products).map(([code, product]) => ({ title: product.chinese_name, value: code, type: product.product_type, category: category })))),
        { title: '其他', value: '其他', type: '其他', category: '其他' }
      ]
    },
    moduleOptions () {
      return [
        { title: '市場吸引力', value: 'market_attractiveness' },
        { title: '市場競爭力', value: 'market_competitiveness' },
        { title: '零售價格分析', value: 'product_prices' },
        { title: '其他', value: 'others' }
      ]
    },
    countryOptions () {
      return this.countrys.map(([key, value]) => ({
        title: value.chinese_name + '(' + value.iso_name + ')',
        value: key,
        country: value
      }))
    },
    formOptions () {
      return {
        field1: [
          {
            title: '報告名稱',
            value: 'title',
            type: 'input',
            placeholder: () => '報告名稱',
            validate: 'required'
          },
          {
            title: '報告年份',
            value: 'year',
            type: 'select',
            width: '200px',
            options: this.yearOptions,
            placeholder: () => '報告年份'
          },
          {
            title: '發表時間',
            value: 'publish_time',
            type: 'datetime',
            width: '200px',
            placeholder: () => '發表時間',
            validate: 'required'
          }
        ],
        field2: [
          {
            title: '產品類別',
            value: 'category',
            type: 'select',
            width: '200px',
            options: this.categoryOptions,
            placeholder: () => '產品類別'
          },
          {
            title: '產品名稱',
            value: 'product_code',
            type: 'select',
            options: this.productOptions.filter(option => option.category === this.result.category),
            placeholder: () => '產品名稱'
          },
          {
            title: '分析類別',
            value: 'module',
            type: 'select',
            width: '200px',
            options: this.moduleOptions,
            placeholder: () => '分析類別'
          }
        ],
        field3: [
          {
            title: '國家',
            value: 'country',
            type: 'datalist',
            lists: this.countryOptions.map(option => option.title),
            onChange: value => {
              if (value && !this.countryOptions.some(option => option.title === value)) {
                this.report = {
                  ...this.report,
                  ...this.result,
                  country: ''
                }
              }
            },
            placeholder: () => '請選擇國家'
          },
          {
            title: '　',
            value: '_ADDCOUNTRY'
          }
        ],
        field4: [
          {
            title: '報告內容',
            value: '_CONTENT'
          }
        ],
        field5: [
          {
            title: '外部連結',
            value: 'external_link',
            type: 'input',
            placeholder: () => '外部連結'
          },
          {
            title: '封面照片',
            value: '_COVERS',
            width: '200px'
          }
        ],
        field6: [
          {
            title: '附件檔案',
            value: '_FILES'
          }
        ]
      }
    },
    quillOptions () {
      let toolbar = [
        [ // 文字大小: [small, normal, large, huge] - false為normal且會成為預設選項
          { 'size': ['small', false, 'large', 'huge'] }
        ],
        [
          'bold', // 粗體
          'italic', // 斜體
          'underline', // 底線
          'strike', // 刪除線
          'link' // 鏈結
        ],
        [
          { 'color': [] }, // 文字顏色
          { 'background': [] } // 背景顏色
        ],
        [ // 列表: [ordered, bullet]
          {'list': 'ordered'},
          {'list': 'bullet'}
        ],
        [
          { 'align': [] } // 文字對齊
        ],
        [ // 縮排: 縮排多寡
          {'indent': '-1'},
          {'indent': '+1'}
        ],
        [
          'clean' // 清除樣式
        ]
      ]
      return {
        modules: {
          toolbar: toolbar
        },
        placeholder: '',
        readonly: false,
        theme: 'snow'
      }
    },
    // global
    convertFileSize () { return convertFileSize },
    fileTypeCheck () { return fileTypeCheck }
  },
  watch: {
    'result.category' (nv, ov) {
      if (ov) {
        this.report = {
          ...this.report,
          ...this.result,
          product_code: ''
        }
      }
    }
  },
  methods: {
    async fetchData () {
      await this.fetchProductByCategorys()
      await this.fetchReport()
    },
    async fetchProductByCategorys () {
      try {
        let config = this.$ls.get('userInfo')
        let response = await getProductByCategorys(config)
        let productByCategorys = response.data
        this.productByCategorys = productByCategorys
      } catch (error) {
        throw error
      }
    },
    async fetchReport () {
      if (this.param.data) {
        try {
          let config = this.$ls.get('userInfo')
          let id = this.param.data.id
          let response = await getAdminReport(id, config)
          let defaultData = response.data.data
          defaultData = {
            ...defaultData,
            publish_time: dateFormat(new Date(defaultData.publish_time), 'yyyy-MM-ddThh:mm'),
            category: (this.productOptions.find(option => option.value === defaultData.product_code) || {}).category || '其他',
            product_code: defaultData.product_code || '其他'
          }
          this.selectedCountrys = this.countryOptions.filter(option => defaultData.countries.includes(option.value))
          this.covers = defaultData.cover_photo ? [
            {
              id: defaultData.cover_photo.id,
              name: defaultData.cover_photo.name,
              size: defaultData.cover_photo.file_size,
              url: defaultData.cover_photo.url
            }
          ] : []
          this.files = defaultData.attachments.map(file => ({
            id: file.id,
            name: file.name,
            size: file.file_size,
            url: file.url
          }))
          this.defaultData = defaultData
        } catch (error) {
          throw error
        }
      }
    },
    async afterSetData () {
      this.report = {
        ...this.report,
        ...this.defaultData
      }
    },
    addCountry () {
      let country = this.countryOptions.find(option => option.title === this.result.country)
      this.report = {
        ...this.report,
        ...this.result,
        country: ''
      }
      if (country) {
        this.selectedCountrys.push(country)
      }
    },
    removeCountry (country) {
      this.selectedCountrys.splice(this.selectedCountrys.indexOf(country), 1)
    },
    async fileUpload (e) {
      let files = Array.from(e.target.files)
      // let limit = Math.max(2 - this.allFiles.length, 0)
      e.target.value = ''
      // files = files.slice(0, limit)
      this.addFiles = [
        ...this.addFiles,
        ...files
      ]
      this.alerts = {
        ...this.alerts,
        _FILES: null
      }
    },
    removeFile (file) {
      if (!file.lastModified) {
        this.removeFileIDs.push(file.id)
        this.files.splice(this.files.indexOf(file), 1)
      } else {
        this.addFiles.splice(this.addFiles.indexOf(file), 1)
      }
    },
    async coverUpload (e) {
      let covers = Array.from(e.target.files)
      let limit = Math.max(1 - this.allCovers.length, 0)
      e.target.value = ''
      covers = covers.slice(0, limit)
      let urls = await imageReader(covers, 'blobUrl')
      for (let i = 0; i < urls.length; i++) {
        covers[i].url = urls[i]
      }
      this.addCovers = [
        ...this.addCovers,
        ...covers
      ]
      this.alerts = {
        ...this.alerts,
        _COVERS: null
      }
    },
    removeCover (cover) {
      if (!cover.lastModified) {
        this.removeCoverIDs.push(cover.id)
        this.covers.splice(this.covers.indexOf(cover), 1)
      } else {
        this.addCovers.splice(this.addCovers.indexOf(cover), 1)
      }
    },
    onEditor (key, e) {
      if (key === 'change') {
        if (this.result.content !== e.html) {
          this.result = {
            ...this.report,
            ...this.result,
            content: e.html
          }
        }
      }
    },
    formOnChange (field, result, validate, errors) {
      this.$set(this.error, field, errors)
      this.$set(this.validate, field, validate)
      this.result = {
        ...this.result,
        ...result
      }
    },
    customValidate (cols, rcols = []) {
      // const isSubmit = !cols
      const validates = {
      }
      for (let col of cols || Object.keys(this.report)) {
        let alert = (validates[col] || (() => {}))(this.result[col])
        this.alerts = {
          ...this.alerts,
          [col]: alert || null
        }
      }
      this.alerts = {
        ...this.alerts,
        ...rcols.reduce((s, c) => ({ ...s, [c]: null }), {})
      }
      return !Object.values(this.alerts).filter(x => x).length
    },
    async validateEditReport () {
      let result = {}
      this.onSubmit = true
      for (let kv of Object.entries(this.validate)) {
        result[kv[0]] = await kv[1].validate()
      }
      result['custom'] = this.customValidate()
      if (!Object.values(result).includes(false)) {
        await this.editReport()
      }
      this.onSubmit = false
    },
    async editReport () {
      try {
        let config = this.$ls.get('userInfo')
        let id = (this.param.data || {}).id
        let data = {
          ...this.result,
          year: this.result.year === '無' ? '' : this.result.year,
          product_code: this.result.product_code === '其他' ? '' : this.result.product_code,
          countries: this.selectedCountrys.map(country => country.value),
          cover_photo: this.addCovers[0],
          attachments: this.addFiles
        }
        if (id) {
          data.remove_attachment_ids = this.removeFileIDs
          data.cover_photo = this.removeCoverIDs.length && !data.cover_photo ? '' : data.cover_photo
        }
        let response = id ? await putAdminReport(id, data, config) : await postAdminReport(data, config)
        this.addToast('success', response.data.result || (id ? '更新成功' : '上傳成功'))
        this.$emit('changeModal', {}, true)
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.message || error.response.data.errors.join('<br>'))
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/editReport.vue